import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

const networkOptions = [
    {
        name: 'Ethernet',
        value: 'net',
    },
    {
        name: 'WiFi',
        value: 'wifi',
    },
    // {
    //     name: 'Cellular',
    //     value: 'cell',
    // },
];


export default class NetworkDisconnectedNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Network Disconnected';
        this.id = 'node_disconnected_network';
        this.icon = 'VscDebugDisconnect';
        this.linkedFeature = 'general';

        this.outputs = [
            {
                name: '',
                portId: 'disconnected_network',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'NETWORK_TYPE',
                name: 'Network Type',
                settingType: SettingType.OPTION,
                required: true,
                default: 'net',
                options: networkOptions,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDependencies(): string[] {
        const NETWORK_TYPE = this.getSettingValue('NETWORK_TYPE');
        if (NETWORK_TYPE === 'wifi') {
            return ['wifi'];
        }
        return [];
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const NETWORK_TYPE = this.getSettingValue('NETWORK_TYPE');
            if (NETWORK_TYPE) {
                let network_name;
                for (let i = 0; i < networkOptions.length; i++) {
                    if (networkOptions[i].value === NETWORK_TYPE) {
                        network_name = networkOptions[i].name;
                    }
                }
                return `On {{$${network_name}}} Disconnected`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const NETWORK_TYPE = this.getSettingValue('NETWORK_TYPE');
        if (NETWORK_TYPE) {
            let network_name;
            for (let i = 0; i < networkOptions.length; i++) {
                if (networkOptions[i].value === NETWORK_TYPE) {
                    network_name = networkOptions[i].name;
                }
            }
            return `On {{$${network_name}}} disconnected}`;
        }
        return this.name;
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const NETWORK_TYPE = this.getSettingValue('NETWORK_TYPE');

        const links = project.getNodeLinks(this, 'disconnected_network');
        if (links.length > 0) {
            for (let i = 0; i < links.length; i++) {
                const link = links[i];
                blocks.push({
                    location: `callback_${NETWORK_TYPE}_disconnected`,
                    blockType: BlockType.CODE,
                    id: link.getSourceId(),
                    template: `'****${link.getSourceId()}****'`,
                });
            }
        }
        return blocks;
    }

    getDetails(): string {
        return `
`;
    }
}
